/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Car\CarCostOffline\CarCostOffline.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Monday October 7th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday October 7th 2024 9:26:09 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import SpanStyled from "Theme/Component/PricingSpan";
import Styles from "Content/Car/CarCostOffline/CarCostOffline.module.css";

type CarCostOfflineProps = {
    customText: string,
    themeColor: string
}

export default function CarCostOffline(props: CarCostOfflineProps) {
    return (
        <div className={`${Styles.offline}`}>
            <SpanStyled bgColor={props.themeColor} >
                {props.customText.toUpperCase()}
            </SpanStyled>
            <p className="mt-3 mb-0">{translator.decode("carCost.login")}</p>
        </div>
    );
}
